




































import { Component, Vue } from "vue-property-decorator";
import * as firebase from 'firebase';
import firebaseui from "@/libs/firebaseui/npm__ja.js";

@Component
export default class LoginNavigation extends Vue {

  private isAuthUi: boolean = false;
  private isLoading: boolean | string = false;

  mounted (): void {
    this.$nextTick(() => {
      if (!this.isAuthUi) {
        const uiConfig = {
          callbacks: {
            signInSuccessWithAuthResult: (authResult, redirectUrl) => {
              // User successfully signed in.
              // Return type determines whether we continue the redirect automatically
              // or whether we leave that to developer to handle.
              console.log('==============> Auth Success');
              console.log(authResult);
              console.log(redirectUrl);
              return true;
            }
          },
          signInFlow: 'popup',
          // ログイン完了時のリダイレクト先
          signInSuccessUrl: this.$store.state.publicPath + '/logged-in',

          // 利用する認証機能
          signInOptions: [
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.FacebookAuthProvider.PROVIDER_ID,
            firebase.auth.TwitterAuthProvider.PROVIDER_ID
          ]
        };

        let ui: firebaseui.auth.AuthUI;
        if (firebaseui.auth.AuthUI.getInstance()) {
          // 既に一度AuthUIを作成している場合はそのインスタンスを使用する
          ui = firebaseui.auth.AuthUI.getInstance();
        }
        else {
          // まだAuthUIの作成をしていない場合はUIのインスタンスを作成する
          ui = new firebaseui.auth.AuthUI(firebase.auth());
        }
        ui.start('#oauthLoginUi', uiConfig);

        this.isAuthUi = true;
      }
    });
  }

  protected onClickGuestLogin (ev: MouseEvent): void {
    this.isLoading = 'primary';
    firebase.auth().signInAnonymously()
      .then((result) => {
        this.isLoading = false;
        this.$store.dispatch('login')
          .then((result) => {
            // ゲストでのログイン成功
            console.log('Login Guest Success');
          })
          .catch((err) => {
            // ToDo エラーイベントを返す
            console.log(err);
          });
      })
      .catch((err) => {
        this.isLoading = false;

        // Handle Errors here.
        const errorCode = err.code;
        const errorMessage = err.message;

        if (errorCode === 'auth/operation-not-allowed') {
          alert('You must enable Anonymous auth in the Firebase Console.');
        } else {
          console.error(err);
        }

        // ToDo エラーイベントを返す
      });
  }

}
